export const translations = {
  en: {
    nav: { fleet: "Fleet", destinations: "Destinations", philosophy: "Philosophy", contact: "Contact", enquire: "Enquire" },
    hero: {
      overline: "Malta Adria — Luxury Yacht Charter",
      line1: "Beyond Luxury.",
      line2: "Beyond the Horizon.",
      sub: "Private yacht and mega yacht charters across the Mediterranean's most coveted waters — from the Côte d'Azur to the Adriatic. Fifteen years of uncompromising seamanship.",
      ctaPrimary: "Explore the Fleet",
      ctaSecondary: "Plan Your Charter",
      scroll: "Scroll",
    },
    stats: [
      { value: "15+", label: "Years at sea" },
      { value: "40+", label: "Vessels in fleet" },
      { value: "5", label: "Countries" },
      { value: "24/7", label: "Concierge" },
    ],
    marquee: ["Malta Adria", "Côte d'Azur", "Greece", "Malta", "Italy", "Croatia", "Luxury Yacht Charter"],
    fleet: {
      overline: "The Fleet",
      title: "Vessels of Distinction",
      sub: "Hand-selected yachts and mega yachts, each crewed by career mariners and maintained to a single, uncompromising standard.",
      categories: { mega: "Mega Yacht", motor: "Motor Yacht", sailing: "Sailing Yacht" },
      specs: { loa: "LOA", guests: "Guests", cabins: "Cabins", crew: "Crew" },
      from: "From",
      perWeek: "/ week",
      enquire: "Enquire",
      vessels: {
        aurum: "A 62-metre flagship with private beach club, helipad and glass infinity pool — the definitive statement on any horizon.",
        sovereign: "Tri-deck elegance with a full-beam master suite, spa deck and zero-speed stabilisers for effortless crossings.",
        maltastar: "Fresh from a 2024 refit — sundeck jacuzzi, alfresco cinema and a toy garage built for the Grand Harbour and beyond.",
        riviera: "A sleek 34-metre cruiser made for champagne runs between Saint-Tropez, Portofino and Hvar.",
        sirocco: "Classic lines, modern soul — a 36-metre sailing yacht for those who let the wind write the itinerary.",
      },
    },
    destinations: {
      overline: "Destinations",
      title: "Five Coasts, One Standard",
      sub: "Our home waters — charted, known and loved for fifteen years.",
      items: {
        riviera: { name: "French Riviera", tag: "Côte d'Azur", desc: "Saint-Tropez, Monaco, Cannes — the original playground of the yachting elite." },
        greece: { name: "Greece", tag: "Cyclades & Ionian", desc: "Whitewashed harbours and anchorages older than history itself." },
        malta: { name: "Malta", tag: "Grand Harbour", desc: "Valletta's bastions, Comino's Blue Lagoon and 300 days of sun." },
        italy: { name: "Italy", tag: "Amalfi & Sardinia", desc: "Capri, Positano, Porto Cervo — la dolce vita, best served from the water." },
        croatia: { name: "Croatia", tag: "The Adriatic", desc: "A thousand islands from Dubrovnik to Split — the Mediterranean as it once was." },
      },
    },
    manifesto: {
      overline: "Philosophy",
      title: "The Malta Adria Standard",
      chapters: [
        { num: "01", title: "Sovereign Freedom", desc: "No schedules but yours. No harbours but the ones you choose. A Malta Adria charter is the rare luxury of absolute autonomy — the sea, arranged around you." },
        { num: "02", title: "Artisanal Seamanship", desc: "Fifteen years, one standard. Our captains and crew are career mariners who treat every crossing as a craft and every guest as a private invitation." },
        { num: "03", title: "Bespoke Itineraries", desc: "From Portofino mornings to Dubrovnik evenings, every route is drawn by hand — yours and ours — then refined until it reads like a memoir." },
      ],
      imageCaption: "Master suite, M/Y Aurum One",
    },
    contact: {
      overline: "Contact",
      title: "Begin Your Voyage",
      sub: "Tell us where the wind should take you. Our concierge replies within 24 hours.",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone (optional)",
        vessel: "Vessel of interest",
        vesselAny: "No preference — advise me",
        destination: "Destination",
        destinationAny: "Open to suggestions",
        dates: "Preferred dates (optional)",
        message: "Your message",
        submit: "Send Enquiry",
        sending: "Sending…",
      },
      success: "Enquiry sent — our concierge will reply within 24 hours.",
      error: "Something went wrong. Please try again or reach us on WhatsApp.",
      details: { title: "Charter Office", addressLabel: "Address", oibLabel: "OIB", emailLabel: "Email", phoneLabel: "Phone / WhatsApp" },
    },
    footer: {
      tagline: "Luxury yacht charter across the Mediterranean — Côte d'Azur, Greece, Malta, Italy and Croatia.",
      navTitle: "Navigate",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
    whatsapp: { tooltip: "Chat with us on WhatsApp" },
  },

  de: {
    nav: { fleet: "Flotte", destinations: "Reiseziele", philosophy: "Philosophie", contact: "Kontakt", enquire: "Anfragen" },
    hero: {
      overline: "Malta Adria — Luxus-Yachtcharter",
      line1: "Jenseits des Luxus.",
      line2: "Jenseits des Horizonts.",
      sub: "Private Yacht- und Megayacht-Charter in den begehrtesten Gewässern des Mittelmeers — von der Côte d'Azur bis zur Adria. Fünfzehn Jahre kompromisslose Seemannschaft.",
      ctaPrimary: "Flotte entdecken",
      ctaSecondary: "Charter planen",
      scroll: "Scrollen",
    },
    stats: [
      { value: "15+", label: "Jahre auf See" },
      { value: "40+", label: "Schiffe in der Flotte" },
      { value: "5", label: "Länder" },
      { value: "24/7", label: "Concierge" },
    ],
    marquee: ["Malta Adria", "Côte d'Azur", "Griechenland", "Malta", "Italien", "Kroatien", "Luxus-Yachtcharter"],
    fleet: {
      overline: "Die Flotte",
      title: "Schiffe mit Charakter",
      sub: "Handverlesene Yachten und Megayachten — besetzt von Berufsseeleuten und nach einem einzigen, kompromisslosen Standard gepflegt.",
      categories: { mega: "Megayacht", motor: "Motoryacht", sailing: "Segelyacht" },
      specs: { loa: "Länge", guests: "Gäste", cabins: "Kabinen", crew: "Crew" },
      from: "Ab",
      perWeek: "/ Woche",
      enquire: "Anfragen",
      vessels: {
        aurum: "Ein 62-Meter-Flaggschiff mit privatem Beach Club, Helipad und Infinity-Glaspool — das ultimative Statement am Horizont.",
        sovereign: "Tri-Deck-Eleganz mit Master-Suite über die volle Breite, Spa-Deck und Zero-Speed-Stabilisatoren für mühelose Überfahrten.",
        maltastar: "Frisch aus dem Refit 2024 — Jacuzzi auf dem Sonnendeck, Open-Air-Kino und eine Toy-Garage für den Grand Harbour und darüber hinaus.",
        riviera: "Ein eleganter 34-Meter-Cruiser für Champagner-Törns zwischen Saint-Tropez, Portofino und Hvar.",
        sirocco: "Klassische Linien, moderne Seele — eine 36-Meter-Segelyacht für alle, die den Wind die Route schreiben lassen.",
      },
    },
    destinations: {
      overline: "Reiseziele",
      title: "Fünf Küsten, ein Anspruch",
      sub: "Unsere Heimatgewässer — seit fünfzehn Jahren befahren, gekannt und geliebt.",
      items: {
        riviera: { name: "Französische Riviera", tag: "Côte d'Azur", desc: "Saint-Tropez, Monaco, Cannes — der ursprüngliche Spielplatz der Yachting-Elite." },
        greece: { name: "Griechenland", tag: "Kykladen & Ionisches Meer", desc: "Weiß getünchte Häfen und Ankerplätze, älter als die Geschichte selbst." },
        malta: { name: "Malta", tag: "Grand Harbour", desc: "Vallettas Bastionen, die Blaue Lagune von Comino und 300 Tage Sonne." },
        italy: { name: "Italien", tag: "Amalfi & Sardinien", desc: "Capri, Positano, Porto Cervo — la dolce vita, am schönsten vom Wasser aus." },
        croatia: { name: "Kroatien", tag: "Die Adria", desc: "Tausend Inseln von Dubrovnik bis Split — das Mittelmeer, wie es einst war." },
      },
    },
    manifesto: {
      overline: "Philosophie",
      title: "Der Malta-Adria-Standard",
      chapters: [
        { num: "01", title: "Souveräne Freiheit", desc: "Keine Zeitpläne außer Ihren. Keine Häfen außer denen, die Sie wählen. Eine Malta-Adria-Charter ist der seltene Luxus absoluter Autonomie — das Meer, um Sie arrangiert." },
        { num: "02", title: "Handwerkliche Seemannschaft", desc: "Fünfzehn Jahre, ein Standard. Unsere Kapitäne und Crews sind Berufsseeleute, die jede Überfahrt als Handwerk begreifen und jeden Gast als private Einladung." },
        { num: "03", title: "Maßgeschneiderte Routen", desc: "Von Portofino-Morgen zu Dubrovnik-Abenden — jede Route wird von Hand gezeichnet, Ihrer und unserer, und verfeinert, bis sie sich liest wie ein Memoir." },
      ],
      imageCaption: "Master-Suite, M/Y Aurum One",
    },
    contact: {
      overline: "Kontakt",
      title: "Beginnen Sie Ihre Reise",
      sub: "Sagen Sie uns, wohin der Wind Sie tragen soll. Unser Concierge antwortet innerhalb von 24 Stunden.",
      form: {
        name: "Vollständiger Name",
        email: "E-Mail-Adresse",
        phone: "Telefon (optional)",
        vessel: "Gewünschtes Schiff",
        vesselAny: "Keine Präferenz — beraten Sie mich",
        destination: "Reiseziel",
        destinationAny: "Offen für Vorschläge",
        dates: "Wunschtermine (optional)",
        message: "Ihre Nachricht",
        submit: "Anfrage senden",
        sending: "Wird gesendet…",
      },
      success: "Anfrage gesendet — unser Concierge antwortet innerhalb von 24 Stunden.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder erreichen Sie uns über WhatsApp.",
      details: { title: "Charter-Büro", addressLabel: "Adresse", oibLabel: "OIB", emailLabel: "E-Mail", phoneLabel: "Telefon / WhatsApp" },
    },
    footer: {
      tagline: "Luxus-Yachtcharter im gesamten Mittelmeer — Côte d'Azur, Griechenland, Malta, Italien und Kroatien.",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
    whatsapp: { tooltip: "Chatten Sie mit uns auf WhatsApp" },
  },

  fr: {
    nav: { fleet: "Flotte", destinations: "Destinations", philosophy: "Philosophie", contact: "Contact", enquire: "Demander" },
    hero: {
      overline: "Malta Adria — Location de Yachts de Luxe",
      line1: "Au-delà du luxe.",
      line2: "Au-delà de l'horizon.",
      sub: "Locations privées de yachts et méga-yachts dans les eaux les plus convoitées de la Méditerranée — de la Côte d'Azur à l'Adriatique. Quinze ans de navigation sans compromis.",
      ctaPrimary: "Découvrir la flotte",
      ctaSecondary: "Planifier votre charter",
      scroll: "Défiler",
    },
    stats: [
      { value: "15+", label: "Années en mer" },
      { value: "40+", label: "Navires dans la flotte" },
      { value: "5", label: "Pays" },
      { value: "24/7", label: "Conciergerie" },
    ],
    marquee: ["Malta Adria", "Côte d'Azur", "Grèce", "Malte", "Italie", "Croatie", "Location de Yachts de Luxe"],
    fleet: {
      overline: "La Flotte",
      title: "Des Navires d'Exception",
      sub: "Yachts et méga-yachts triés sur le volet, armés par des marins de carrière et entretenus selon un seul standard, sans compromis.",
      categories: { mega: "Méga-Yacht", motor: "Yacht à Moteur", sailing: "Voilier" },
      specs: { loa: "Longueur", guests: "Invités", cabins: "Cabines", crew: "Équipage" },
      from: "À partir de",
      perWeek: "/ semaine",
      enquire: "Demander",
      vessels: {
        aurum: "Un flagship de 62 mètres avec beach club privé, hélipad et piscine à débordement en verre — la déclaration ultime sur tout horizon.",
        sovereign: "Élégance sur trois ponts avec suite principale pleine largeur, pont spa et stabilisateurs zéro vitesse pour des traversées sans effort.",
        maltastar: "Tout juste sorti d'un refit 2024 — jacuzzi sur le pont soleil, cinéma en plein air et un garage à toys pensé pour le Grand Harbour et au-delà.",
        riviera: "Un croiseur élancé de 34 mètres, fait pour les traversées champagne entre Saint-Tropez, Portofino et Hvar.",
        sirocco: "Lignes classiques, âme moderne — un voilier de 36 mètres pour ceux qui laissent le vent écrire l'itinéraire.",
      },
    },
    destinations: {
      overline: "Destinations",
      title: "Cinq Côtes, Un Seul Standard",
      sub: "Nos eaux d'attache — sillonnées, connues et aimées depuis quinze ans.",
      items: {
        riviera: { name: "Côte d'Azur", tag: "Riviera français", desc: "Saint-Tropez, Monaco, Cannes — le terrain de jeu originel de l'élite du yachting." },
        greece: { name: "Grèce", tag: "Cyclades & Ionienne", desc: "Des ports blanchis à la chaux et des mouillages plus anciens que l'histoire." },
        malta: { name: "Malte", tag: "Grand Harbour", desc: "Les bastions de La Valette, le Lagon Bleu de Comino et 300 jours de soleil." },
        italy: { name: "Italie", tag: "Amalfi & Sardaigne", desc: "Capri, Positano, Porto Cervo — la dolce vita, mieux servie depuis l'eau." },
        croatia: { name: "Croatie", tag: "L'Adriatique", desc: "Mille îles de Dubrovnik à Split — la Méditerranée comme autrefois." },
      },
    },
    manifesto: {
      overline: "Philosophie",
      title: "Le Standard Malta Adria",
      chapters: [
        { num: "01", title: "Liberté Souveraine", desc: "Aucun horaire sauf le vôtre. Aucun port sauf ceux que vous choisissez. Un charter Malta Adria, c'est le luxe rare de l'autonomie absolue — la mer, arrangée autour de vous." },
        { num: "02", title: "Navigation Artisanale", desc: "Quinze ans, un seul standard. Nos capitaines et équipages sont des marins de carrière qui traitent chaque traversée comme un artisanat et chaque invité comme une invitation privée." },
        { num: "03", title: "Itinéraires Sur Mesure", desc: "Des matins de Portofino aux soirées de Dubrovnik, chaque route est tracée à la main — la vôtre et la nôtre — puis affinée jusqu'à se lire comme un mémoire." },
      ],
      imageCaption: "Suite principale, M/Y Aurum One",
    },
    contact: {
      overline: "Contact",
      title: "Commencez Votre Voyage",
      sub: "Dites-nous où le vent doit vous porter. Notre conciergerie répond sous 24 heures.",
      form: {
        name: "Nom complet",
        email: "Adresse e-mail",
        phone: "Téléphone (optionnel)",
        vessel: "Navire souhaité",
        vesselAny: "Aucune préférence — conseillez-moi",
        destination: "Destination",
        destinationAny: "Ouvert aux suggestions",
        dates: "Dates souhaitées (optionnel)",
        message: "Votre message",
        submit: "Envoyer la demande",
        sending: "Envoi en cours…",
      },
      success: "Demande envoyée — notre conciergerie répond sous 24 heures.",
      error: "Une erreur est survenue. Veuillez réessayer ou nous contacter sur WhatsApp.",
      details: { title: "Bureau Charter", addressLabel: "Adresse", oibLabel: "OIB", emailLabel: "E-mail", phoneLabel: "Téléphone / WhatsApp" },
    },
    footer: {
      tagline: "Location de yachts de luxe à travers la Méditerranée — Côte d'Azur, Grèce, Malte, Italie et Croatie.",
      navTitle: "Naviguer",
      contactTitle: "Contact",
      rights: "Tous droits réservés.",
    },
    whatsapp: { tooltip: "Discutez avec nous sur WhatsApp" },
  },

  hr: {
    nav: { fleet: "Flota", destinations: "Destinacije", philosophy: "Filozofija", contact: "Kontakt", enquire: "Upit" },
    hero: {
      overline: "Malta Adria — Luksuzni Yacht Charter",
      line1: "Iznad luksuza.",
      line2: "Iznad horizonta.",
      sub: "Privatni najam jahti i mega jahti u najpoželjnijim vodama Mediterana — od Azurne obale do Jadrana. Petnaest godina beskompromisnog pomorstva.",
      ctaPrimary: "Istražite flotu",
      ctaSecondary: "Planirajte charter",
      scroll: "Skrolaj",
    },
    stats: [
      { value: "15+", label: "Godina na moru" },
      { value: "40+", label: "Plovila u floti" },
      { value: "5", label: "Zemalja" },
      { value: "24/7", label: "Concierge" },
    ],
    marquee: ["Malta Adria", "Azurna obala", "Grčka", "Malta", "Italija", "Hrvatska", "Luksuzni Yacht Charter"],
    fleet: {
      overline: "Flota",
      title: "Plovila s Karakterom",
      sub: "Pažljivo odabrane jahte i mega jahte — s posadama profesionalnih pomoraca i održavane prema jednom, beskompromisnom standardu.",
      categories: { mega: "Mega jahta", motor: "Motorna jahta", sailing: "Jedrilica" },
      specs: { loa: "Dužina", guests: "Gostiju", cabins: "Kabina", crew: "Posada" },
      from: "Od",
      perWeek: "/ tjedan",
      enquire: "Upit",
      vessels: {
        aurum: "Flagship od 62 metra s privatnim beach clubom, helikopterskom pistom i staklenim infinity bazenom — vrhunska izjava na svakom horizontu.",
        sovereign: "Elegancija na tri palube s master kabinom preko pune širine, spa palubom i zero-speed stabilizatorima za lagodne plovidbe.",
        maltastar: "Svježe iz refita 2024. — jacuzzi na sunčanoj palubi, kino na otvorenom i garaža za toys građena za Grand Harbour i dalje.",
        riviera: "Elegantna 34-metarska krstarica stvorena za champagne plovidbe između Saint-Tropeza, Portofina i Hvara.",
        sirocco: "Klasične linije, moderne duše — 36-metarska jedrilica za one koji vjetru prepustaju pisanje itinerara.",
      },
    },
    destinations: {
      overline: "Destinacije",
      title: "Pet Obala, Jedan Standard",
      sub: "Naša matična mora — plovljena, poznata i voljena petnaest godina.",
      items: {
        riviera: { name: "Azurna obala", tag: "Côte d'Azur", desc: "Saint-Tropez, Monako, Cannes — izvorno igralište yachting elite." },
        greece: { name: "Grčka", tag: "Cikladi i Jonsko more", desc: "Bijelo krečene luke i sidrišta starija od same povijesti." },
        malta: { name: "Malta", tag: "Grand Harbour", desc: "Vallettine utvrde, Plava laguna Comina i 300 dana sunca." },
        italy: { name: "Italija", tag: "Amalfi i Sardinija", desc: "Capri, Positano, Porto Cervo — la dolce vita, najbolje poslužena s vode." },
        croatia: { name: "Hrvatska", tag: "Jadran", desc: "Tisuću otoka od Dubrovnika do Splita — Mediteran kakav je nekad bio." },
      },
    },
    manifesto: {
      overline: "Filozofija",
      title: "Malta Adria Standard",
      chapters: [
        { num: "01", title: "Suverena sloboda", desc: "Nema rasporeda osim vašeg. Nema luka osim onih koje odaberete. Malta Adria charter je rijetki luksuz apsolutne autonomije — more, ustrojeno oko vas." },
        { num: "02", title: "Obrtno pomorstvo", desc: "Petnaest godina, jedan standard. Naši kapetani i posade su karijerni pomorci koji svaku plovidbu doživljavaju kao obrt, a svakog gosta kao privatnu pozivnicu." },
        { num: "03", title: "Itinerari po mjeri", desc: "Od portofinskih jutara do dubrovačkih večeri — svaka ruta crta se rukom, vašom i našom, pa brusi dok se ne čita kao memoari." },
      ],
      imageCaption: "Master kabina, M/Y Aurum One",
    },
    contact: {
      overline: "Kontakt",
      title: "Započnite Svoje Putovanje",
      sub: "Recite nam kamo vas vjetar treba ponijeti. Naš concierge odgovara unutar 24 sata.",
      form: {
        name: "Ime i prezime",
        email: "Email adresa",
        phone: "Telefon (neobavezno)",
        vessel: "Željeno plovilo",
        vesselAny: "Bez preferencije — savjetujte me",
        destination: "Destinacija",
        destinationAny: "Otvoren/a sam za prijedloge",
        dates: "Željeni datumi (neobavezno)",
        message: "Vaša poruka",
        submit: "Pošalji upit",
        sending: "Šaljem…",
      },
      success: "Upit poslan — naš concierge odgovorit će unutar 24 sata.",
      error: "Nešto je pošlo po zlu. Pokušajte ponovno ili nam pišite na WhatsApp.",
      details: { title: "Charter ured", addressLabel: "Adresa", oibLabel: "OIB", emailLabel: "Email", phoneLabel: "Telefon / WhatsApp" },
    },
    footer: {
      tagline: "Luksuzni yacht charter diljem Mediterana — Azurna obala, Grčka, Malta, Italija i Hrvatska.",
      navTitle: "Navigacija",
      contactTitle: "Kontakt",
      rights: "Sva prava pridržana.",
    },
    whatsapp: { tooltip: "Razgovarajte s nama na WhatsAppu" },
  },
};

export const languageNames = { en: "EN", de: "DE", fr: "FR", hr: "HR" };
